import {
  ShoppingCart,
  User,
  Search,
  LogOut,
  Heart,
  Bell,
  ClipboardList,
  Ticket,
} from "lucide-react";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState, useRef } from "react";
import { useCart } from "../../context/CartContext";

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname + location.search;

  const username = localStorage.getItem("username");
  const [showMenu, setShowMenu] = useState(false);
  const timeoutRef = useRef(null);
  const [searchText, setSearchText] = useState("");


  // ⭐ Use resetLocalCart only
  const { cartItems, resetLocalCart } = useCart();

  const cartCount = cartItems.reduce((total, item) => total + item.quantity, 0);

  // ⭐ Logout → only local cart clear, backend safe
  const handleLogout = () => {
    const currentPath = location.pathname + location.search;

    resetLocalCart(); // clear only UI cart

    localStorage.removeItem("token");
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("username");

    setShowMenu(false);

    if (
      currentPath.includes("/shop") ||
      currentPath.includes("/product") ||
      currentPath.includes("/cart") ||
      currentPath.includes("/checkout")
    ) {
      navigate("/shop", { replace: true });
    } else {
      navigate("/home", { replace: true });
    }

    window.location.reload();
  };

  const handleMouseEnter = () => {
    clearTimeout(timeoutRef.current);
    setShowMenu(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => setShowMenu(false), 150);
  };

  return (
    <header className="sticky top-0 z-50 bg-white shadow-sm border-b border-gray-100">
      <div className="w-full flex items-center justify-between px-6 py-3">

        {/* LOGO */}
        <div className="text-3xl font-extrabold tracking-tight flex items-center gap-1">
  <span className="text-orange-500">HRGF</span>
  <span className="text-blue-600">.com</span>
</div>


        {/* SEARCH BAR */}
        <div className="flex items-center w-1/2 bg-gray-100 rounded-2xl px-3 py-1 shadow-inner border border-gray-200">

          <input
  type="text"
  placeholder="Search for products, brands and more"
  className="w-full px-4 py-2 bg-gray-100 outline-none text-sm"
  value={searchText}
  onChange={(e) => setSearchText(e.target.value)}
  onKeyDown={(e) => {
    if (e.key === "Enter" && searchText.trim() !== "") {
      navigate(`/all-products?q=${searchText.trim()}`);

    }
  }}
/>

          <button
  className="px-4 text-gray-600 hover:text-indigo-600"
  onClick={() => {
    if (searchText.trim() !== "") {
     navigate(`/all-products?q=${searchText.trim()}`);

    }
  }}
>
  <Search size={18} />
</button>

        </div>

        {/* RIGHT SIDE MENU */}
        <div className="flex items-center gap-5 text-gray-700 relative">

          {/* IF LOGGED IN */}
          {username ? (
            <div
              className="relative z-50"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <button className="flex items-center gap-2 text-sm hover:text-indigo-600">
                <User size={18} /> My Account ▾
              </button>

              {showMenu && (
                <div
                  className="absolute right-0 top-full w-56 bg-white border border-gray-200 shadow-xl rounded-md z-50"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="bg-indigo-600 text-white px-4 py-2 rounded-t-md flex justify-between items-center text-sm font-medium">
                    <span>Hello, {username}</span>
                  </div>

                  <div className="py-2 text-sm">
                    <Link to="/dashboard/profile" className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100">
                      <User size={16} /> My Profile
                    </Link>
                    <Link to="/orders" className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100">
                      <ClipboardList size={16} /> Orders
                    </Link>
                    <Link to="/dashboard/wishlist" className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100">
                      <Heart size={16} /> Wishlist
                    </Link>
                    <Link to="/coupons" className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100">
                      <Ticket size={16} /> Coupons
                    </Link>
                    <Link to="/notifications" className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100">
                      <Bell size={16} /> Notifications
                    </Link>

                    <button
                      onClick={handleLogout}
                      className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 text-red-500 w-full text-left"
                    >
                      <LogOut size={16} /> Logout
                    </button>
                  </div>
                </div>
              )}
            </div>
          ) : (
            // IF NOT LOGGED IN
            <div
              className="relative z-50"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <button
                onClick={() => navigate("/login", { state: { from: currentPath } })}
                className="flex items-center gap-2 text-sm hover:text-indigo-600"
              >
                <User size={18} /> Login ▾
              </button>

              {showMenu && (
                <div
                  className="absolute right-0 top-full w-56 bg-white border border-gray-200 shadow-xl rounded-md z-50"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="bg-indigo-600 text-white px-4 py-2 rounded-t-md flex justify-between items-center text-sm font-medium">
                    <span>New customer?</span>
                    <Link to="/signup" className="underline hover:text-gray-100 text-xs">
                      Sign Up
                    </Link>
                  </div>

                  <div className="py-2 text-sm">
                    <Link
                      to="/login"
                      state={{ from: currentPath }}
                      className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100"
                    >
                      <User size={16} /> My Profile
                    </Link>
                    <Link to="/orders" className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100">
                      <ClipboardList size={16} /> Orders
                    </Link>
                    <Link to="/wishlist" className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100">
                      <Heart size={16} /> Wishlist
                    </Link>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* CART BUTTON */}
          {/* CART BUTTON — hide ONLY on Cart Page */}
{location.pathname !== "/cart" && (
  <Link
    to="/cart"
    className="relative flex items-center gap-2 hover:text-indigo-600 text-sm"
  >
    <div className="relative">
      <ShoppingCart size={22} />

      {cartCount > 0 && (
        <span className="absolute -top-2 -right-2 bg-orange-500 text-white text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center z-50 shadow-md">
          {cartCount}
        </span>
      )}
    </div>
    <span>Cart</span>
  </Link>
)}


        </div>
      </div>

      {/* CATEGORY BAR */}
      {/* <div className="bg-indigo-600 text-white flex justify-center gap-6 py-2 text-xs md:text-sm font-medium">
        <span>Electronics</span>
        <span>Fashion</span>
        <span>Home</span>
        <span>Beauty</span>
        <span>Sports</span>
        <span>Grocery</span>
      </div> */}
    </header>
  );
}
